import React from "react";

import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import "./StartButtonStyle.css";

const StartButton = () => {
  let navigate = useNavigate();
  function goToSearch() {
    navigate("/search");
  }

  return (
    <button className="startButton gradient-primary" onClick={goToSearch}>
      <FaSearch />
      Hörsaalsuche starten
    </button>
  );
};

export default StartButton;
